/**
 * Login redirect — sends unauthenticated users to Cognito Managed Login.
 *
 * If the user is already authenticated, redirects to /suggestions.
 * Otherwise, initiates the OAuth login flow immediately.
 */

import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import LoadingSpinner from '@/components/shared/LoadingSpinner'

export default function LoginRedirect() {
  const { isAuthenticated, isLoading, login } = useAuth()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login()
    }
  }, [isLoading, isAuthenticated, login])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <LoadingSpinner text="Checking authentication..." />
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/suggestions" replace />
  }

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <LoadingSpinner text="Redirecting to sign in..." />
    </div>
  )
}
